/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.edit.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.validate',
  'acme.common.service.helpers',
  'acme.common.factory.notice',
  'acme.common.factory.gridState'
])

.controller('PartnersEditController', ['$scope', '$state', '$q', '$filter', '$uibModal', '$timeout', 'ApiService', 'ValidateService', 'HelpersService', 'NoticeFactory','CategoriesData', 'GridStateFactory', function($scope, $state, $q, $filter, $uibModal, $timeout, ApiService, ValidateService, HelpersService, NoticeFactory, CategoriesData, GridStateFactory) {

    $scope.partnersEdit = {

      pageType: 'Create',
      isEditEnabled: false,
      submitText: 'Create',
      organizationId: '',

      isSubmitting: false,
      isSubmitted: false,
      model: {
        company: {
          name: '',
          streetAddress1: '',
          streetAddress2: '',
          city: '',
          state: '',
          country: '',
          phoneNumber: '',
          companyUrl: ''
        },
        primaryContact: {
          id: false,
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          accountId: false,
          primary: true
        },
        category: {
          id: ''
        }
      },

      payment: {
        id: false,
        type: 'fullPayment',
        accountId: false,
        uniqueVoucherNumbers: false,
        ticketDelivery: 'print',
        balanceDueDays: 0,
        depositDueDays: 0,
        depositMinimumAmount: 0,
        depositMinimumPercent: 0
      },

      secondaryContacts: [],

      removedSecondaryContacts: [],

      gridState: new GridStateFactory(),

      grid: {
        pageSize: 10,
        paginate: true,
        useExternalPagination: true,
        useExternalSorting: true,
        multiselect: false,
        showFooter: false,
        columns: [
          {
            field: 'edit',
            displayName: '',
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.edit(row.entity)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.firstName }}{{ row.entity.lastName }}</span></a></div>',
            width: 60
          },
          {
            field: 'id',
            displayName: 'ID',
            visible: false
          },
          {
            field: 'firstName',
            displayName: 'First Name'
          },
          {
            field: 'lastName',
            displayName: 'Last Name'
          },
          {
            field: 'email',
            displayName: 'Email'
          },
          {
            field: 'phoneNumber',
            displayName: 'Phone Number'
          },
          {
            field: 'streetAddress1',
            displayName: 'Address 1'
          },
          {
            field: 'city',
            displayName: 'City'
          },
          {
            field: 'state',
            displayName: 'State'
          },
          {
            field: 'country',
            displayName: 'Country'
          },
          {
            field: 'zipCode',
            displayName: 'Zip Code'
          },
          {
            field: 'remove',
            displayName: '',
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
            width: 80
          }
        ]
      },

      notes: '',

      notice: new NoticeFactory(),

      savedPayment: {},
      selectedCategory: {},

      categories: [],

      viewId: $state.current.name,

      loadPreferences: $state.current.data.enablePreferences,

      primaryContactAddress: false,

      init: function() {

        var titleText = 'Create Organization';

        if ($state.params.hasOwnProperty('accountId')) {
          this.pageType = 'Edit';
          this.isEditEnabled = true;
          this.submitText = 'Update';
          titleText = 'Edit Organization';
        }

        $scope.$emit('Application::contentTitleChange', {
          title: titleText,
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $scope.partnersEdit.cancel();
            }
          },
          buttonRight: {
            label: $scope.partnersEdit.submitText,
            action: function() {
              if ($scope.partnersEdit.isEditEnabled) {
                $scope.partnersEdit.update();
              }else {
                $scope.partnersEdit.create();
              }
            }
          }
        });

        if ($state.params.accountId) {
          this.organizationId = $state.params.accountId;
        }

        if (CategoriesData.data && CategoriesData.data.success) {
          this.success.getCategories(CategoriesData);
        }else {
          this.error.getCategories(CategoriesData);
        }

        if (this.isEditEnabled) {
          this.getAccount($state.params.accountId);
          this.getAccountPayment($state.params.accountId);

          this.gridState.updateGridState(null, this.grid.pageSize, 'firstName');
          this.getAccountContacts($state.params.accountId);
        }

        $scope.$on('AddressList::Create', this.onAddressListCreate);
        $scope.$on('AddressList::Edit', this.onAddressListEdit);
        $scope.$on('AddressList::PrimaryAddress', this.onAddressListPrimaryAddress);
        $scope.$on('AddressDetail::Change', this.onAddressDetailChange);
        $scope.$on('AddressDetail::Edit', this.onAddressDetailEdit);

      },

      getAccount: function(accountId) {
        ApiService.partners.detail(accountId).then(this.success.init, this.error.init);
      },

      getAccountPayment: function(accountId) {
        ApiService.partners.payments.account(accountId).then(this.success.getAccountPayment, this.error.getAccountPayment);
      },

      getAccountContacts: function(accountId) {
        ApiService.organizations.contacts.list($.extend({ organizationId: accountId }, this.gridState.getGridState())).then(this.success.getAccountContacts, this.error.getAccountContacts);
      },

      isValidCategory: function() {

        var r = true;

        if (this.isSubmitted) {
          r = (this.selectedCategory && this.selectedCategory.hasOwnProperty('id'));
        }

        return r;
      },

      isValidCompany: function(field) {

        var r = true;

        if (this.isSubmitted) {
          r = ValidateService.validate([
            {
              len: {
                value: this.model.company[field]
              }
            }
          ]);
        }

        return r;
      },

      isValidContactFirst: function(prop) {
        var r = true;

        if (this.isSubmitted) {

          r = ValidateService.validate([
            {
              len: {
                value: prop
              }
            },
            {
              name: prop
            }
          ]);
        }

        return r;
      },

      isValidContactLast: function(prop) {
        var r = true;

        if (this.isSubmitted) {

          r = ValidateService.validate([
            {
              len: {
                value: prop
              }
            },
            {
              name: prop
            }
          ]);
        }

        return r;
      },

      isValidPhone: function(prop) {
        var r = true;

        if (this.isSubmitted) {

          r = ValidateService.validate([
            {
              phone: prop
            }
          ]);
        }

        return r;
      },

      isValidEmail: function(email) {
        var r = true;

        if (this.isSubmitted) {
          r = ValidateService.validate([{ email: email }]);
        }

        return r;
      },

      filterContacts: function(contacts, primary) {
        var filtered = [], i, ii;
        for(i = 0, ii = contacts.length; i < ii; i++) {
          if(contacts[i].primary === primary) {
            filtered.push(contacts[i]);
          }
        }
        return filtered;
      },

      findContact: function(contacts, id) {
        var r = {index: -1}, i, ii;
        for(i = 0, ii=contacts.length;i < ii; i++) {
          if(contacts[i].id === id) {
            r.contact = contacts[i];
            r.index = i;
            break;
          }
        }
        return r;
      },

      addSecondaryContact: function() {
        var self = $scope.partnersEdit;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/create/modals/ManageSecondaryContactModal.tpl.html',
          size: 'lg',
          controller: 'ManageSecondaryContactModalController',
          resolve: {
            ValidateService: function() {
              return ValidateService;
            },
            alertMessage: function() {
              return null;
            },
            organizationId: function() {
              return $state.params.accountId;
            },
            organizationName: function() {
              return $state.params.accountName;
            },
            contact: function() {
              return null;
            },
            address: function() {
              return null;
            }
          }
        });

        self.addModal.result.then(function(contact) {
            //add the secondaryContact
            if(contact){
              //add the index property to manage this contact locally (not stored on server yet)
              contact.index = self.secondaryContacts.length;
            }
            self.secondaryContacts.push(contact);
          },
          function() {
            //do nothing
          });
      },


      removeSecondaryContact: function(row) {
        var self = $scope.partnersEdit, index = -1;
        //first see if this is an existing contact.
        if(row.entity.id) {
          index = (self.findContact(self.secondaryContacts, row.entity.id)).index;
        }
        else if(row.entity.index !== undefined) {
          index = row.entity.index;
        }
        if(index > -1) {
          self.removeModal = $uibModal.open({
            templateUrl: 'views/application/views/partners/create/modals/RemoveSecondaryContactModal.tpl.html',
            size: 'lg',
            controller: 'RemoveSecondaryContactModalController',
            resolve: {
              ValidateService: function () {
                return ValidateService;
              },
              contact: function () {
                return self.secondaryContacts[index];
              }
            }
          });

          self.removeModal.result.then(function () {
              //remove the secondaryContact
              if(row.entity.id) {
                //remove later when page is saved
                self.removedSecondaryContacts.push( (self.secondaryContacts.splice(index,1))[0]);
              }else {
                self.secondaryContacts.splice(index,1);
              }
            },
            function () {
              //do nothing
            });
        }
      },

      editSecondaryContact: function(item) {
        var self = $scope.partnersEdit, index = -1;
        if(item.id) {
          index = (self.findContact(self.secondaryContacts, item.id)).index;
        }
        else if(item.index !== undefined) {
          index = item.index;
        }
        if(index > -1) {
          self.editModal = $uibModal.open({
            templateUrl: 'views/application/views/partners/create/modals/ManageSecondaryContactModal.tpl.html',
            size: 'lg',
            controller: 'ManageSecondaryContactModalController',
            resolve: {
              ValidateService: function() {
                return ValidateService;
              },
              alertMessage: function() {
                return null;
              },
              organizationId: function() {
                return $state.params.accountId;
              },
              organizationName: function() {
                return $state.params.accountName;
              },
              contact: function() {
                return self.secondaryContacts[index];
              },
              address: function() {
                return null;
              }
            }
          });

          self.editModal.result.then(function(contact, address) {
              //update the secondaryContact
              if (contact) {
                self.secondaryContacts[index] = contact;
              }
              $scope.$broadcast('AddressList::Refresh');
            },
            function() {
              $scope.$broadcast('AddressList::Refresh');
            }
          );
        }
      },

      changeAddress: function(type, contactId, address) {
        var self = $scope.partnersEdit;

        self.changeAddressModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/create/modals/SelectAddressModal.tpl.html',
          size: 'lg',
          controller: 'SelectAddressModalController',
          resolve: {
            organizationId: function() {
              return $state.params.accountId;
            },
            contactId: function() {
              return contactId;
            },
            address: function() {
              return address;
            }
          }
        });

        self.changeAddressModal.result.then(function(address) {
            $scope.$broadcast('AddressDetail::Update', { type: type, contactId: contactId, address: address });
            $scope.$broadcast('AddressList::Refresh');
          },
          function() {
            $scope.$broadcast('AddressList::Refresh');
          }
        );

      },

      createEditAddress: function(address) {
        var self = $scope.partnersEdit;

        self.editAddressModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/create/modals/CreateEditAddressModal.tpl.html',
          size: 'md',
          controller: 'CreateEditAddressModalController',
          resolve: {
            organizationId: function() {
              return $state.params.accountId;
            },
            address: function() {
              return address || null;
            },
            preventSave: function() {
              return true;
            }
          }
        });

        self.editAddressModal.result.then(function(address) {
            var i, ii;

            $scope.$broadcast('AddressDetail::Update', { address: address });
            $scope.$broadcast('AddressList::Refresh');
            // Update visible secondary contacts
            for (i=0,ii=self.secondaryContacts.length;i<ii;i++) {
              if ("" + self.secondaryContacts[i].addressId === "" + address.addressId) {
                self.secondaryContacts[i].streetAddress1 = address.streetAddress1;
                self.secondaryContacts[i].streetAddress2 = address.streetAddress2;
                self.secondaryContacts[i].city = address.city;
                self.secondaryContacts[i].state = address.state;
                self.secondaryContacts[i].country = address.country;
                self.secondaryContacts[i].zipCode = address.zipCode;
                break;
              }
            }
          },
          function() {
            //do nothing
            $scope.$broadcast('AddressList::Refresh');
          }
        );
      },

      createPayment: function(accountId) {
        if (accountId) {
          this.savedPayment.accountId = accountId;
          ApiService.partners.payments.create(this.savedPayment).then(this.success.createPayment, this.error.createPayment);
        }else{
          this.notice.showErrorMessages([
            { message: 'There was a problem updating the payment policy.' }
          ]);
        }
      },

      savePayment: function(payment) {
        this.savedPayment = payment;
      },

      create: function() {

        var validators = [
          { phone: this.model.company.phoneNumber },
          { len: { value: this.model.company.name } },
          { len: { value: this.model.company.streetAddress1 } },
          { len: { value: this.model.company.city } },
          { len: { value: this.model.company.country } },
          { email: this.model.primaryContact.email },
          { phone: this.model.primaryContact.phoneNumber },
          { name: this.model.primaryContact.firstName },
          { name: this.model.primaryContact.lastName }
        ];

        if (this.validateCountryStates()) {
          validators.push({ len: { value: this.model.company.state } });
        }

        this.isSubmitted = true;

        if (this.isValidCategory()) {
          // Copy category id into model before saving
          this.model.category.id = this.selectedCategory.id;

          if (ValidateService.validate(validators)) {
            ApiService.partners.create(this.model).then(this.success.create, this.error.create);
          } else {
            console.log('PartnersEditController::create', ValidateService.errors);
            this.notice.showErrorMessages([
              { message: 'Please correct the errors below.' }
            ]);
          }
        }else{
          this.notice.showErrorMessages([
            { message: 'Please select an organization category.' }
          ]);
        }
      },

      processSecondaryContacts: function(accountId) {
        var self = $scope.partnersEdit, createdPromises = [];

        createdPromises = self.secondaryContacts.map(function (secondaryContact) {
          var props = secondaryContact;

          if(props.id) {
            return ApiService.organizations.contacts.update(props);
          }else {
            props.organizationId = accountId;
            return ApiService.organizations.contacts.create(props);
          }
        });

        createdPromises.concat( self.removedSecondaryContacts.map( function(secondaryContact) {
          return ApiService.organizations.contacts.remove({
            contactId: secondaryContact.id,
            organizationId: accountId
          });
        }));

        $q.all(createdPromises).then(self.success.processSecondaryContacts, self.error.processSecondaryContacts);
      },

      createPrimaryContact: function() {

        var q = $q.defer(),
            primaryContactData = angular.extend({}, this.primaryContactAddress); // Get primary address and append to new contact creation

        // We can only create a new contact if there is a primary address in place.
        if (primaryContactData.id) {
          if (!primaryContactData.addressId) {
            primaryContactData.addressId = primaryContactData.id;
          }
          primaryContactData.id = null;
          delete primaryContactData.id;

          primaryContactData = angular.extend(primaryContactData, this.model.primaryContact);
          if (!primaryContactData.organizationId) {
            primaryContactData.organizationId = this.model.company.id;
          }

          /**
           * NOTE: Create primary contact on POST does not work
           * so we must create a secondary contact and promote it via update
           */

          ApiService.organizations.contacts.create(primaryContactData).then(function (response) {
            var data = response.data.payload;

            data.isPrimary = true;
            data.primary = true;

            ApiService.organizations.contacts.update(data).then(function(response) {
              q.resolve(response);
            }, function(response) {
              q.reject(response);
            });
          });
        }else{
          $timeout(function() {
            q.reject({
              data: {
                error: 'No primary address exists. Create or Edit an address and make it the primary address for this organization.'
              }
            });
          }, 10);
        }

        return q.promise;

      },

      validateCountryStates: function() {
        return  (
          this.model.company.country && 
          (
            this.model.company.country === 'Canada' || 
            this.model.company.country === 'United States'
          )
        );
      },

      update: function() {
        //update is in 4 steps:
        // 1. update account (company) info
        // 2. update account user info (primary contact)
        // 3. update account payment info
        // 4. update category relation
        // 5. update account notes

        var primaryContactData = {},
            accountUpdatePromises = [],
            validators = [
              { phone: this.model.company.phoneNumber },
              { len: { value: this.model.company.name, description: "Company Name" } },
              { len: { value: this.model.company.streetAddress1, description: "Street address" } },
              { len: { value: this.model.company.city, description: "City" } },
              { len: { value: this.model.company.country, description: "Country" } },
              { email: this.model.primaryContact ? this.model.primaryContact.email : '' },
              { phone: this.model.primaryContact ? this.model.primaryContact.phoneNumber : '' },
              { name: this.model.primaryContact ? this.model.primaryContact.firstName : '' },
              { name: this.model.primaryContact ? this.model.primaryContact.lastName : '' }
            ];

        if (this.validateCountryStates()) {
          validators.push({ len: { value: this.model.company.state, description: "State" } });
        }

        this.isSubmitted = true;

        if (this.isValidCategory()) {

          if (ValidateService.validate(validators)) {

            accountUpdatePromises.push( ApiService.partners.update(this.model) );

            if (this.model.primaryContact && !this.model.primaryContact.accountId) {
              this.model.primaryContact.accountId = this.model.company.id;
            }

            if (this.model.primaryContact && this.model.primaryContact.id) {
              accountUpdatePromises.push( ApiService.partners.user.update(this.model.primaryContact) );
            }else{
              accountUpdatePromises.push( this.createPrimaryContact() );
            }

            // if payment is changed, update payment
            if(this.savedPayment.accountId) {
              accountUpdatePromises.push( ApiService.partners.payments.update(this.savedPayment) );
            }

            if (this.model.accountCategoryRelation) {
              accountUpdatePromises.push( ApiService.partners.categories.reassign({
                id: this.model.accountCategoryRelation.id,
                accountId: this.model.accountCategoryRelation.accountId,
                categoryId: this.selectedCategory.id
              }) );
            }else{
              accountUpdatePromises.push( ApiService.partners.categories.assign({
                accountId: this.model.company.id,
                categoryId: this.selectedCategory.id
              }) );
            }

            accountUpdatePromises.push( ApiService.partners.notes.update({
              id: this.model.requests[0].requestId,
              notes: this.notes
            }) );

            $q.all(accountUpdatePromises).then(this.success.update, this.error.update);

          } else {
            console.log('PartnersEditController::update', ValidateService.errors);

            var msg = 'Please correct the errors below. Organization primary address and primary contact are required.';

            // check for non-input fields errors such as address city, state and country etc
            var addressErrors = ValidateService.errors.filter(function(error) {
              return error.payload && error.payload.len && error.payload.len.description;
            });

            if (addressErrors.length > 0) {
              //check for input field errors
              if (addressErrors.length === ValidateService.errors.length) {
                msg = '';
              } else {
                msg += ' ';
              }

              msg += addressErrors.map(function(error){
                return error.payload.len.description;
              }).join(", ");

              msg += addressErrors.length === 1 ? ' is required.' : ' are required.';
            }

            this.notice.showErrorMessages([
              { message: msg }
            ]);
          }
        }else{
          this.notice.showErrorMessages([
            { message: 'Please select an organization category.' }
          ]);
        }
      },

      complete: function() {
        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();

        this.isSubmitting = true;
        this.isSubmitted = false;
        // Make sure payment data gets copied before ajax request is sent to create account
        $scope.$broadcast('PaymentOptions::save');
        if(this.isEditEnabled) {
          this.update();
        }else {
          this.create();
        }
      },

      cancel: function() {
        if(this.isEditEnabled) {
          $state.go('application.partners.detail', { id: this.model.company.id });
        }else {
          $state.go('application.partners.list.default');
        }
      },

      findAccountCategory: function(name) {
        var i, ii,
          r = false,
          self = $scope.partnersEdit;

        for (i=0,ii=self.categories.length;i<ii;i++) {
          if (name === self.categories[i].name) {
            r = {
              index: i,
              category: self.categories[i]
            };
            break;
          }
        }
        console.log('PartnersEditController::findAccountCategory', r, name, self.categories);

        return r;
      },

      unmarshalPayment: function(paymentObj) {
        var payment,
        deposit = paymentObj.desposit || {daysBeforeEvent: 0, minAmount: 0, percent: 0};
        payment = {
          id: paymentObj.id,
          type: paymentObj.type,
          accountId: paymentObj.accountId,
          uniqueVoucherNumbers: paymentObj.uniqueVoucherNumbers,
          ticketDelivery: paymentObj.ticketDelivery,
          balanceDueDays: paymentObj.balanceDue ? paymentObj.balanceDue.days : 0,
          depositDueDays: deposit.daysBeforeEvent || 0,
          depositMinimumAmount: deposit.minAmount || 0,
          depositMinimumPercent: deposit.percent || 0
        };
        return payment;
      },

      success: {
        init: function(response) {
          var self = $scope.partnersEdit;
          self.model = response.data.payload;
          self.payment.accountId = self.model.company.id;
          self.notes = (self.model.requests[0]) ? self.model.requests[0].posNotes : '';
          if (self.model.accountCategoryRelation) {
            self.selectedCategory = self.findAccountCategory(self.model.accountCategoryRelation.categoryName).category;
          }
          $scope.$broadcast('AddressDetail::Update', { type: 'org', contactId: self.model.company.id, address: self.model.company });
          if (self.model.primaryContact) {
            $scope.$broadcast('AddressDetail::Update', { type: 'contact', contactId: self.model.primaryContact.id, address: self.model.primaryContact });
          }
        },

        getAccountPayment: function(response) {
          var self = $scope.partnersEdit;
          self.payment = self.unmarshalPayment(response.data.payload);
        },

        getAccountContacts: function(response) {
          var self = $scope.partnersEdit;
          self.secondaryContacts = self.filterContacts(response.data.payload.list, false);
          self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
          //TODO: filter out primary contact?
        },

        create: function(response) {

          var self = $scope.partnersEdit;
          // When account has been created apply the payment policy to the account
          // Since we copied the result of the payment directive before the request was sent
          // It should be ready for us.
          // Apply the payment policy to the new partner account
          self.model.company.id = response.data.payload.company.id;
          self.isEditEnabled = true;
          self.createPayment(response.data.payload.company.id);
        },
        createPayment: function(response) {
          console.log('Success::CreatePayment', response);
          // create secondary contacts for this account
          $scope.partnersEdit.processSecondaryContacts($scope.partnersEdit.model.company.id);
        },
        processSecondaryContacts: function(response) {
          var self = $scope.partnersEdit;
          self.isSubmitted = true;
          self.isSubmitting = false;
          $state.go('application.partners.detail', { id: self.model.company.id });
        },

        update: function(response) {
          var self = $scope.partnersEdit;
          self.processSecondaryContacts(self.model.company.id);
        },

        getCategories: function(response) {
          $scope.partnersEdit.categories = response.data.payload.list;
        }
      },

      error: {
        init: function(response) {},

        create: function(response) {
          var self = $scope.partnersEdit;

          self.isSubmitted = true;
          self.isSubmitting = false;
          self.notice.hideSuccessMessages();
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        createPayment: function(response) {
          var self = $scope.partnersEdit;

          self.isSubmitted = true;
          self.isSubmitting = false;
          self.notice.hideSuccessMessages();
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        processSecondaryContacts: function(response) {
          var self = $scope.partnersEdit;

          self.isSubmitted = true;
          self.isSubmitting = false;
          self.notice.hideSuccessMessages();
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        update: function(response) {
          var self = $scope.partnersEdit;

          self.isSubmitted = true;
          self.isSubmitting = false;
          self.notice.hideSuccessMessages();
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        getCategories: function(response) {},
        getAccountPayment: function(response) {},
        getAccountContacts: function(response) {}
      },

      // When payment has process from directive continue with completion
      onPaymentUpdate: function(payment) {
        $scope.partnersEdit.savePayment(payment);
      },

      gridDoubleClick: function(item) {
        $scope.partnersEdit.editSecondaryContact(item.entity);
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.partnersEdit;
        self.gridState.updateGridState(newPage, pageSize);
        self.getAccountContacts($state.params.accountId);
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.partnersEdit, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getAccountContacts($state.params.accountId);
        }
      },

      onAddressDetailChange: function(e, data) {
        $scope.partnersEdit.changeAddress(data.type, data.contactId, data.address);
      },

      onAddressDetailEdit: function(e, data) {
        $scope.partnersEdit.createEditAddress(data.address);
      },

      onAddressListCreate: function(e, data) {
        $scope.partnersEdit.createEditAddress();
      },

      onAddressListEdit: function(e, data) {
        $scope.partnersEdit.createEditAddress(data.address);
      },

      onAddressListPrimaryAddress: function(e, data) {
        var self = $scope.partnersEdit;

        self.primaryContactAddress = data.address;
      }

    };

    $scope.partnersEdit.init();

}]);